import React, { useEffect, useState } from 'react';
import { Observer } from 'mobx-react';
import Modal from 'react-modal';
import { env } from '../../env';
import { getMenuIcon } from '../icons/menu';
import { HOST_TO_URL } from '../../store/auth/auth.constants';
import LinksUserModal from './links-user-modal';


const LinksModal = ({ isOpen, onRequestClose, selectedCredId }) => {

  const [credData, setCredData] = useState({
    isLinkUserModalOpened: false,
    linkId: null,
    id: selectedCredId,
    links: []
  });

  const [spanTexts, setSpanTexts] = useState({});
  const [shareTexts, setShareTexts] = useState({});


  const onLinkUserModalOpen = (linkId) => {
    setCredData({...credData, isLinkUserModalOpened: true, linkId});
  };

  const onLinkUserModalClose = () => {
    setCredData({...credData, isLinkUserModalOpened: false, linkId: null});
  };


  const handleCredFetch = async (credId) => {
    try {
      const data = await env.http
        .get(`shares/${credId}`)
        .then(response => response.data);

      setCredData({...credData, links: data.links}
      );
    } catch (e) {
      console.log(e);
      env.alert(
        'Ошибка',
        `Ошибка. Данные не получены.<br /><br /> Тип ошибки: <br />${e.response.data.error_message}`
      );
    }
  };

  const buildLinkBody = () => {
    if (!credData.links)
        return null;

    const body = credData.links.map(link => {
                    let watchButton = (
                        <button
                          className='links_watch_button'
                          onClick={() => window.open(`${HOST_TO_URL['of']}${link.share_link}`, '_blank')}
                        >
                          {getMenuIcon('proxy')}
                        </button>
                    );

                    let shareButton = (
                        <button
                          className='links_share_button'
                          onClick={() => {
                            if (navigator.clipboard) {
                              navigator.clipboard.writeText(`${HOST_TO_URL['of']}${link.share_link}`);
                            } else {
                              let textarea = document.createElement('textarea');
                              textarea.textContent = `${HOST_TO_URL['of']}${link.share_link}`;
                              document.body.appendChild(textarea);
                              textarea.select();
                              document.execCommand('copy');
                              document.body.removeChild(textarea);
                            }

                            setShareTexts(prevShareTexts => ({
                              ...prevShareTexts,
                              [link.id]: 'Link Copied!'
                            }));
                            setTimeout(() => {
                              setShareTexts(prevShareTexts => ({
                                ...prevShareTexts,
                                [link.id]: null
                              }));
                            }, 3000);
                          }}
                        >
                          {shareTexts[link.id] || 'Share'}
                        </button>
                      );

                    const handleCopyLink = (link_url) => {
                        if (navigator.clipboard) {
                            navigator.clipboard.writeText(link_url);
                        } else {
                            let textarea = document.createElement('textarea');
                            textarea.textContent = link_url;
                            document.body.appendChild(textarea);
                            textarea.select();
                            document.execCommand('copy');
                            document.body.removeChild(textarea);
                        }
                        setSpanTexts(prevSpanTexts => ({
                          ...prevSpanTexts,
                          [link.id]: 'copied!'
                        }));
                        setTimeout(() => {
                          setSpanTexts(prevSpanTexts => ({
                            ...prevSpanTexts,
                            [link.id]: null
                          }));
                        }, 3000);
                    }

                    return (
                    <tr key={link.id}>
                        <td style={{ flex: 1 }}>{link.name}<br />
                            <div className='link-copy'>
                                <span 
                                  onClick={() => handleCopyLink(link.url)} 
                                  style={{ color: (!spanTexts[link.id] || spanTexts[link.id] === null) ? 'blue' : 'green'}}>
                                  {spanTexts[link.id] || 'copy link'}
                                  </span>
                            </div>
                        {link.created_at}
                        </td>
                        <td style={{ flex: 1, alignItems: 'center', paddingLeft: '20px' }}>{link.claims}</td>
                        <td style={{ flex: 1, alignItems: 'center', color: (link.revenue > 0) ? "green" : "black" }}>
                            $ {link.revenue} {(link.revenue_from > 0) ? 
                            <div className='link-copy' onClick={() => onLinkUserModalOpen(link.id)}>
                                <span>from {link.revenue_from} fans</span>
                            </div> : null}
                        </td>
                        <td style={{ flex: 1, alignItems: 'center' }}>{watchButton}</td>
                        <td style={{ flex: 1, alignItems: 'center' }}>{shareButton}</td>
                    </tr>
                    );
                }
            );
    return (body)
  }

  useEffect(() => {
    if (selectedCredId && isOpen) {
      handleCredFetch(selectedCredId);
    }
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={{
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.75)'
        },
        content: {
          width: 'fit-content',
          top: '40%',
          left: '50%',
          transform: 'translate(-50%, -50%)'

        }
      }}>
        <div className='links-body'>
            <div className='links_popup_header'>
                <h2>Ссылки</h2>
                <button onClick={onRequestClose}>
                    {getMenuIcon('close')}
                </button>
            </div>
            <div className='links_popup_content'>
                <table className='table' style={{ tableLayout: 'fixed' }}>
                       <thead className='links-thead' >
                            <tr>
                                <th style={{ flex: 1 }}>Trial link</th>
                                <th style={{ flex: 1 }}>Claims</th>
                                <th style={{ flex: 1 }}>Revenue</th>
                                <th style={{ flex: 1 }}>Watch</th>
                                <th style={{ flex: 1 }}>Share</th>
                            </tr>
                        </thead>
                        <tbody className='links-tbody'>
                            {buildLinkBody()}
                        </tbody>
                </table>
            </div>
        </div>

        <Observer>
            {() => (
              <LinksUserModal
                isOpen={credData.isLinkUserModalOpened}
                onRequestClose={onLinkUserModalClose}
                selectedTrialLinkId={credData.linkId}
              />
            )}
        </Observer>

    </Modal>
    
  );
};

export default LinksModal;
